module.exports = __webpack_public_path__ + "img/logo_intrust.9e8c5b8a.png";